/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { Popover } from '@mui/material';
import VerticalDots from '../img/verticalDots.svg';
import MenuPopup from '../../menuPopup/MenuPopup';
import { levelSourceToDisplayLabel } from '../../../panel/inventory/fuelConfigurator/fuelPolicyApiMapping';
import './ColumnFuelConfigurator.css';

const CustomTitle = ({ row }) => (
    <div>
        <b>{row.name}</b>
    </div>
);

const CustomStatus = ({ row }) => {
    const s = row.status || 'DRAFT';
    return <span className={`fuel-policy-status fuel-policy-status--${String(s).toLowerCase()}`}>{s}</span>;
};

const CustomDate = ({ row }) => {
    const d = row.dateLastEdited;
    if (!d) return <div>—</div>;
    return (
        <div>
            <div className="table-date-text">{d.date}</div>
            <div
                className="table-time-text"
                data-tag="allowRowEvents"
                style={{ color: 'grey' }}
            >
                {d.time}
            </div>
        </div>
    );
};

const CustomMenuButton = ({ row, rowIndex }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [assetRow, setAssetRow] = useState();

    const handleClick = (event) => {
        setAssetRow(row);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAssetRow();
        setAnchorEl(null);
    };

    return (
        <div>
            <div className="assets-button" id={rowIndex} aria-hidden="true" onClick={handleClick}>
                <div className="assets-menu">
                    <img loading="lazy" src={VerticalDots} alt="MenuIcon" />
                </div>
            </div>
            <Popover
                id={rowIndex}
                sx={{ boxShadow: 2, borderRadius: 2 }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuPopup page="adminFuelConfigurator" assetDetails={assetRow} />
            </Popover>
        </div>
    );
};

export const FuelConfiguratorColumn = [
    {
        name: 'Policy Name',
        selector: (row) => row.name,
        sortable: true,
        cell: (row) => <CustomTitle row={row} />,
    },
    {
        name: 'Tank (L)',
        selector: (row) => row.tankCapacityL,
        sortable: true,
    },
    {
        name: 'Level Mapping',
        selector: (row) => levelSourceToDisplayLabel(row.levelSource),
        sortable: true,
    },
    {
        name: 'Status',
        selector: (row) => row.status,
        sortable: true,
        cell: (row) => <CustomStatus row={row} />,
    },
    {
        name: 'Assets Attached',
        selector: (row) => row.assetsAttached,
        sortable: true,
    },
    {
        name: 'Last Edited',
        selector: (row) => row.dateLastEdited?.date,
        sortable: true,
        cell: (row) => <CustomDate row={row} />,
    },
    {
        cell: (row, rowIndex) => <CustomMenuButton row={row} rowIndex={rowIndex} />,
        allowOverflow: true,
        button: true,
        width: '48px',
    },
];
